import React from 'react';
import BaseCheckbox from './BaseCheckbox';
import classNames from 'classnames';
import { useInput } from '../form/hooks/useInput';
const Checkbox = (props) => {
    const { type = 'checkbox', prefixCls = 'checkbox', children, value, ...restProps } = props;
    const { field } = useInput({
        type,
        name: props.name,
    });
    const checkboxProps = {
        ...field,
        // checked: field.value.includes(value),
        ...restProps,
    };
    const classString = classNames(`${prefixCls}-wrapper`, {
        [`${prefixCls}-wrapper-checked`]: checkboxProps.checked,
        [`${prefixCls}-wrapper-disabled`]: checkboxProps.disabled,
    });
    return (React.createElement("label", { className: classString },
        React.createElement(BaseCheckbox, { ...checkboxProps }),
        children !== undefined && React.createElement("span", { className: `${prefixCls}-content` }, children)));
};
if (process.env.NODE_ENV !== 'production') {
    Checkbox.displayName = 'Checkbox';
}
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map